import { Div, Collection, Ref, TableBuilder, Link, Select, SelectOption } from "@tblabs/truffle";
import { PrimaryButton } from "../../../Components/Utils/PrimaryButton";
import { BlogArticle } from "../../../Models/Blog/BlogArticle";
import { ArticleId } from "../../../Models/Blog/ArticleId";
import { ProductCategory } from "../../../Models/Product/ProductCategory";


export class ArticleSelector extends Div
{
    constructor(category: ProductCategory, articles: Collection<BlogArticle>)
    {
        super();

        const selectedArticle = new Ref<ArticleId>("");
        const assignedArticles = articles.Items.filter(x => category.RelatedArticles.Items.includes(x.Id));
        const selectedArticles = new Collection<BlogArticle>(assignedArticles);

        this.Append(
            new TableBuilder<BlogArticle>(selectedArticles)
                .AddColumn("Tytuł", article => article.Title.value)
                .AddColumn("", article => new Link("✖️").OnClick(() => selectedArticles.Remove(article)))
                .Build(),
            new Select(selectedArticle, articles.Items.map(x => new SelectOption(x.Title.value, x.Id))).WidthAuto(),
            new PrimaryButton("Dodaj").OnClick(() =>
            {
                const article = articles.Items.find(x => x.Id === selectedArticle.value);
                if (article)
                {
                    selectedArticles.Add(article);
                    category.RelatedArticles.Add(article.Id);
                }
            })
        );
    }
}
